const NumbersCard = ({black, gray, desc}) => {
    return (
        <div className="flex col numbers-content w-100">
            <div className="flex">
                <span className="numb white">
                    {black.toUpperCase()}
                    <span className="gray">{gray}</span>
                </span>
            </div>
            <hr className="hr white w-100 mb-8"/>
            <div className="fs-16 white">{desc.toUpperCase()}</div>
        </div>
    )
}
export default NumbersCard